export default "__VITE_ASSET__C6cxdt4R__"